// assets
import BarChartOutlined from "@ant-design/icons/BarChartOutlined";
import CameraOutlined from "@ant-design/icons/CameraOutlined";
import CarOutlined from "@ant-design/icons/CarOutlined";
import CheckCircleOutlined from "@ant-design/icons/CheckCircleOutlined";
import EnvironmentOutlined from "@ant-design/icons/EnvironmentOutlined";
import ExperimentOutlined from "@ant-design/icons/ExperimentOutlined";
import FileTextOutlined from "@ant-design/icons/FileTextOutlined";
import PlayCircleOutlined from "@ant-design/icons/PlayCircleOutlined";
import SafetyCertificateOutlined from "@ant-design/icons/SafetyCertificateOutlined";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  CameraOutlined,
  CarOutlined,
  ExperimentOutlined,
  BarChartOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
};

// ==============================|| MENU ITEMS - MAIN PAGES ||============================== //

const mainPages: NavItemType = {
  id: "main-pages",
  type: "group",
  children: [
    {
      id: "validations",
      title: "Validations",
      type: "item",
      url: "/validations",
      icon: icons.SafetyCertificateOutlined,
    },
    {
      id: "simulation",
      title: "Simulator",
      type: "item",
      url: "/simulation",
      icon: icons.PlayCircleOutlined,
    },
  ],
};

export default mainPages;
